import * as angular from "angular";
import {IController} from "angular";

export class AddressesResolverListItem implements IController {

  address: any;
  selected: any;

  onSelect: Function;
  onEdit: Function;
  onDelete: Function;

}

angular
  .module('bringoz.admin.addresses')
  .component('addressesResolverListItem', {
    bindings: {
      address: '<',
      selected: '<',
      onSelect: '&',
      onEdit: '&'
    },
    template: require('./addresses-resolver-list-item.html').default,
    controller: AddressesResolverListItem
  });
